import { render } from "./arrow-right.vue?vue&type=template&id=4ed01176"
import script from "./arrow-right.vue?vue&type=script&lang=js"
export * from "./arrow-right.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__